import { render, staticRenderFns } from "./AlertaBeneficioZonaFranca.vue?vue&type=template&id=8d47b2b0&"
import script from "./AlertaBeneficioZonaFranca.vue?vue&type=script&lang=js&"
export * from "./AlertaBeneficioZonaFranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports